import { makeAutoObservable } from "mobx";

class CompanyStore {
  companyName = "";
  userId = "";
  selectedEmail = "";
  selectedYear = "";
  selectedMonth = "";
  date = "";
  purpose = "";
  debit = "";
  paidTo = "";
  UPI_id = "";
  utr = "";
  txnId = "";
  month = "";
  year = "";
  Company_Id = "";
  email = "";
  txnLimit = "";
  DailyLimit = "";
  MonthlyLimit = "";
  create_at = "";
  minDate = "";
  maxDate = "";
  SelectedPhoneNo = "";
  name = "";
  refresh = true;
  KYCStatus = "";
  kycRejectedReason = "";
  status = "";
  userType = "";
  enabled;
  isUserAdmin;
  isUserOwner;
  UserRoles = [];
  Tags;
  selectedExpenseMobileno=""
  status=""
  category =''
  txnStatus =''
  index =''
  initiateKYC =''

  constructor() {
    makeAutoObservable(this);
    this.hydrate(); // Retrieve stored data on initialization
  }
  setCategory(data) {
    this.category = data;
  }
    setInitiateKYC(data) {
    this.initiateKYC = data;
  }
  setIndex(data) {
    this.index = data;
  }
  setTxnStatus(data) {
    this.txnStatus = data;
  }
  setStatus(data) {
    this.status = data;
  }
  setSelectedExpenseMobileNo(data) {
    this.selectedExpenseMobileno = data;
  }
  setIsUserAdmin(data) {
    this.isUserAdmin = data;
    localStorage.setItem("isUserAdmin", data);
  }
  setIsUserOwner(data) {
    this.isUserOwner = data;
    localStorage.setItem("isUserOwner", data);
  }
  setTags(data) {
    this.Tags = data;
    localStorage.setItem("Tags", data);
  }
  setEnabled(data) {
    this.enabled = data;
    localStorage.setItem("enabled", data);
  }
  setUserType(data) {
    this.userType = data;
    localStorage.setItem("userType", data);
  }
  setStatus(data) {
    this.status = data;
    localStorage.setItem("status", data);
  }
  setKycRejectedReason(data) {
    this.kycRejectedReason = data;
  }
  setKycStatus(data) {
    this.KYCStatus = data;
  }
  setPhoneNo(data) {
    this.SelectedPhoneNo = data;
    localStorage.setItem("SelectedPhoneNo", data);
  }
  setRefresh(data) {
    this.refresh = data;
  }
  setMinDate(data) {
    this.minDate = data;
  }
  setMaxDate(data) {
    this.maxDate = data;
  }
  setCreate_at(data) {
    this.create_at = data;
    localStorage.setItem("create_at", data);
  }
  setName(data) {
    this.name = data;
    localStorage.setItem("name", data);
  }
  setTxnLimit(data) {
    this.txnLimit = data;
    localStorage.setItem("txnLimit", data);
  }
  setDailyLimit(data) {
    this.DailyLimit = data;
    localStorage.setItem("DailyLimit", data);
  }
  setmonthlyLimit(data) {
    this.MonthlyLimit = data;
    localStorage.setItem("MonthlyLimit", data);
  }
  setCompId(data) {
    this.Company_Id = data;
    localStorage.setItem("Company_Id", data);
  }
  setMonth(data) {
    this.year = data;
    localStorage.setItem("year", data);
  }
  setYear(data) {
    this.month = data;
    localStorage.setItem("month", data);
  }
  // Actions to update the fields
  setCompanyName(data) {
    this.companyName = data;
    localStorage.setItem("CompanyName", data);
  }

  setEmail(data) {
    this.email = data;
    localStorage.setItem("email", data);
  }

  setUserId(userId) {
    this.userId = userId;
    localStorage.setItem("userId", userId);
  }

  setSelectedEmail(selectedEmail) {
    this.selectedEmail = selectedEmail;
    localStorage.setItem("selectedEmail", selectedEmail);
  }

  setSelectedYear(selectedYear) {
    this.selectedYear = selectedYear;
    localStorage.setItem("selectedYear", selectedYear);
  }

  setSelectedMonth(selectedMonth) {
    this.selectedMonth = selectedMonth;
    localStorage.setItem("selectedMonth", selectedMonth);
  }

  setDate(date) {
    this.date = date;
    localStorage.setItem("date", date);
  }

  setPurpose(purpose) {
    this.purpose = purpose;
    localStorage.setItem("purpose", purpose);
  }

  setDebit(debit) {
    this.debit = debit;
    localStorage.setItem("debit", debit);
  }

  setPaidTo(paidTo) {
    this.paidTo = paidTo;
    localStorage.setItem("paidTo", paidTo);
  }

  setUPIId(UPI_id) {
    this.UPI_id = UPI_id;
    localStorage.setItem("UPI_id", UPI_id);
  }

  setUtr(utr) {
    this.utr = utr;
    localStorage.setItem("utr", utr);
  }

  setTxnId(txnId) {
    this.txnId = txnId;
    localStorage.setItem("txnId", txnId);
  }

  setUserRoles(data) {
    this.UserRoles = data;
    localStorage.setItem("UserRoles", data);
  }
  // Hydrate the store from localStorage when the app is initialized
  hydrate() {
    const UserOwner = localStorage.getItem("isUserOwner");
    if (UserOwner) this.isUserOwner = UserOwner;

    const UserAdmin = localStorage.getItem("isUserAdmin");
    if (UserAdmin) this.isUserAdmin = UserAdmin;

    const UserRoles = localStorage.getItem("UserRoles");
    if (UserRoles) this.UserRoles = UserRoles;

    const name = localStorage.getItem("name");
    if (name) this.name = name;

    const Tags = localStorage.getItem("Tags");
    if (Tags) this.Tags = Tags;

    const userType = localStorage.getItem("userType");
    if (userType) this.userType = userType;

    const txnLimit = localStorage.getItem("txnLimit");
    if (txnLimit) this.txnLimit = txnLimit;

    const DailyLimit = localStorage.getItem("DailyLimit");
    if (DailyLimit) this.DailyLimit = DailyLimit;

    const MonthlyLimit = localStorage.getItem("MonthlyLimit");
    if (MonthlyLimit) this.MonthlyLimit = MonthlyLimit;

    const Company_Id = localStorage.getItem("Company_Id");
    if (Company_Id) this.Company_Id = Company_Id;

    const storedCompanyName = localStorage.getItem("CompanyName");
    if (storedCompanyName) this.companyName = storedCompanyName;

    const storedEmail = localStorage.getItem("email");
    if (storedEmail) this.email = storedEmail;

    const storedYear = localStorage.getItem("year");
    if (storedYear) this.year = storedYear;

    const storedMonth = localStorage.getItem("month");
    if (storedMonth) this.month = storedMonth;

    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) this.userId = storedUserId;

    const storedSelectedEmail = localStorage.getItem("selectedEmail");
    if (storedSelectedEmail) this.selectedEmail = storedSelectedEmail;

    const storedSelectedYear = localStorage.getItem("selectedYear");
    if (storedSelectedYear) this.selectedYear = storedSelectedYear;

    const storedSelectedMonth = localStorage.getItem("selectedMonth");
    if (storedSelectedMonth) this.selectedMonth = storedSelectedMonth;

    const storedDate = localStorage.getItem("date");
    if (storedDate) this.date = storedDate;

    const storedPurpose = localStorage.getItem("purpose");
    if (storedPurpose) this.purpose = storedPurpose;

    const storedDebit = localStorage.getItem("debit");
    if (storedDebit) this.debit = storedDebit;

    const storedPaidTo = localStorage.getItem("paidTo");
    if (storedPaidTo) this.paidTo = storedPaidTo;

    const storedUPIId = localStorage.getItem("UPI_id");
    if (storedUPIId) this.UPI_id = storedUPIId;

    const storedUtr = localStorage.getItem("utr");
    if (storedUtr) this.utr = storedUtr;

    const storedTxnId = localStorage.getItem("txnId");
    if (storedTxnId) this.txnId = storedTxnId;

    const SelectedPhoneNo = localStorage.getItem("SelectedPhoneNo");
    if (SelectedPhoneNo) this.SelectedPhoneNo = SelectedPhoneNo;

    const status = localStorage.getItem("status");
    if (status) this.status = status;

    const enabled = localStorage.getItem("enabled");
    if (enabled) this.enabled = enabled;
  }
}

const companyStore = new CompanyStore();
export default companyStore;
